import { TemplateRef } from '@angular/core';

export interface Dialog {
  dialogType: DialogType;
  title?: string;
  text?: string;
  onClick?: () => void;
  template?: TemplateRef<any> | null;
  close?: boolean;
  size?: 'sm' | 'lg' | 'xl';
}

export enum DialogType {
  Alert,
  Confirm,
  Custom
}

export enum ToastType {
  Success,
  Error
}

export interface Toast {
  toastType: ToastType;
  message: string;
}
